import process from 'node:process';

/**
 * Whether verbose CLI diagnostics are enabled. Opt-in only, so normal runs stay
 * quiet — set CANARY_DEBUG=1 (or =true) or pass --debug. Diagnostics always go
 * to stderr so they never pollute stdout-piped (`--json`) output.
 */
export function isDebug(): boolean {
  return (
    process.env.CANARY_DEBUG === '1' ||
    process.env.CANARY_DEBUG === 'true' ||
    process.argv.includes('--debug')
  );
}

/** Write a diagnostic line to stderr, but only when debug mode is enabled. */
export function debug(line: string): void {
  if (isDebug()) {
    process.stderr.write(`[canary-debug] ${line}\n`);
  }
}
